/**
 * Log-line prefixes whose `console.*` output must never become a Sentry
 * breadcrumb, because the line carries data our own logs may hold but Sentry
 * may not (e.g. a normalised client IP).
 *
 * Kept dependency-free so the Sentry `beforeBreadcrumb` filter can import it
 * without pulling the emitter (and `redis-client`) into the Sentry init path.
 *
 * Add a prefix here AND use it as the first argument of the `console.*` call,
 * so the two stay greppable together.
 */
export const SENSITIVE_CONSOLE_LOG_PREFIXES = ['[invite-code-throttle]'];
